module.exports = "/images/vendor/flag-icon-css/flags/1x1/de.svg?4d7bac3b0b9ab578b009c54fecd5d06f";